const Contacto = () => {
  return (
    <div>
      <h3>Contacto</h3>
      <p>visita mi web jonmircha.com</p>
    </div>
  );
};

export default Contacto;
